<div id="upload-preview" [style.height.px]="viewHeight">
  <ion-slides #slides (ionSlideDidChange)="slideChanged($event)">
    <ion-slide *ngFor="let file of files; let i = index" (click)="openImagePreview()">
      <div class="slide-wrapper">
        <div *ngIf="file.isVideo === false && file.isEmbedVideo === false && file.isDoc === false" class="slide-image"
           [style.background-image]="'url(' + file.safeUrl + '?ts=' + tsNow + ')'">
          <img *ngIf="file.isBlob" [src]="file.safeUrl">
          <ion-icon *ngIf="showThumbnails !== true && allowRemove" class="remove-img" name="close-circle-outline"
            color="danger" (click)="removeImage(file)">
          </ion-icon>

          <div class="slide-arrows flex-spaced" *ngIf="showSlideArrows && files.length > 1">
            <div>
              <ion-button *ngIf="i != 0" fill="clear" size="large" (click)="moveSlide($event)">
                <ion-icon name="arrow-back-outline"></ion-icon>
              </ion-button>
            </div>
            <div>
              <ion-button *ngIf="i != files.length-1" fill="clear" size="large" (click)="moveSlide($event, 'next')">
                <ion-icon name="arrow-forward-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
        <ng-container *ngIf="file.isVideo === true">
          <canvas id="thumbnail" hidden="hidden"></canvas>
          <video id="video-player" controls="true" loop="true" (click)="videoClicked($event)"
            [attr.poster]="allowRemove === false ? file.thumbPath : null" muted="true"
            [attr.preload]="allowRemove ? 'auto' : 'metadata'" playsinline="true">
            <source *ngFor="let source of file.videoSources" [src]="source.safeUrl" [type]="source.mimeType">
            <source [src]="file.safeUrl" [type]="file.mimeType">
          </video>
        </ng-container>
        <ng-container *ngIf="file.isEmbedVideo === true">
          <iframe width="100%" height="100%" [src]="file.safeUrl" title="Video Link" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </ng-container>
        <ng-container *ngIf="file.isDoc === true">
          <p *ngIf="file.isBlob === false" class="mt20">
            <a [href]="file.safeUrl" target="_blank">View Document</a>
          </p>
          <p *ngIf="file.isBlob" class="ion-text-center">{{file.filename}}</p>
        </ng-container>
        <p class="slide-caption">{{file.description}}</p>
        <ion-icon *ngIf="showThumbnails !== true && allowRemove" class="remove-img" name="close-circle-outline"
          color="danger" (click)="removeImage(file)">
        </ion-icon>
      </div>
    </ion-slide>
    <ion-slide *ngIf="files.length === 0" (click)="browse.emit()">
      <div>
        <h3 *ngIf="files.length === 0">{{uploadTitle}}</h3>
        <p *ngIf="uploadDetails != null">{{uploadDetails}}</p>
      </div>
    </ion-slide>
  </ion-slides>
</div>
<div class="thumbnails" *ngIf="files.length > 1 && showThumbnails">
  <div class="thumb-scroll">
    <div *ngIf="!showSlideArrows" class="thumb-nav">
      <ion-button class="thumb-prev ion-no-padding" fill="clear" size="large" (click)="prev()">
        <ion-icon slot="icon-only" color="primary" name="arrow-back-circle"></ion-icon>
      </ion-button>
    </div>
    <div class="thumbnail-wrapper" [style.max-width]="thumbnailWrapperMaxWidth">
      <div class="thumbnail-row">
        <div class="thumbnail" (click)="setImage(i)" *ngFor="let file of files; index as i"
          [style.height.px]="thumbSize" [style.width.px]="thumbSize" [class.active]="activeIndex === i"
          [style.background-image]="'url(' + file.safeUrl + '?ts=' + tsNow + ')'" [id]="'thumb' + i">
          <img *ngIf="file.isBlob || file.isVideo" [src]="file.thumbPath">
          <img *ngIf="file.isEmbedVideo" src="./assets/img/play.png">
          <ion-icon name="close-circle-outline" color="danger" *ngIf="activeIndex === i && allowRemove"
            (click)="removeImage(file)">
          </ion-icon>
        </div>
      </div>
    </div>
    <div *ngIf="!showSlideArrows" class="thumb-nav">
      <ion-button class="thumb-prev ion-no-padding" fill="clear" size="large" (click)="next()">
        <ion-icon slot="icon-only" name="arrow-forward-circle"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>

<ion-badge color="primary" *ngIf="allowRemove == false && showMagnify == true" class="magnify-badge" (click)="openImagePreview()">
  <span title="Expand Image">
    <ion-icon name="search-outline"></ion-icon>
  </span>
</ion-badge>